import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import Select from "react-select";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import {
  postSubmitForm,
  postSubmitForm_withformdata,
} from "../../../../helpers/forms_helper";
import moment from "moment";
import preloader from "../../../../helpers/preloader";
import {
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../../helpers/units";
import showNotification from "../../../../helpers/show_notification";
import EnterQuantityModal from "../../../../components/EnterQuantityModal";
import UpdateQuantityModal from "../../../../components/UpdateQuantityModal";
import calculatePrice from "../../../../helpers/calculate_price";
import ConfirmationDialogue from "../../../../components/ConfirmationDialogue";
import { CheckExpiryDateValidation } from "../../../../helpers/po_helper";
import ReceiveConfirmationDialog from "../../../../components/ReceiveConfirmationDialog";
import printDiv from "../../../../helpers/print_data";

const FinishedProductView = (props) => {
  const [POItems, setPOItems] = useState([]);
  const [receiveBtnDisabled, setReceiveBtnDisabled] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const oneYearFromNow = moment().add(1, "year").format("YYYY-MM-DD");
  const [dateFrom, setDateFrom] = useState(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    return firstDay;
  });

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const { SearchBar } = Search;
  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));
    loadAllProducts();
  }, []);

  const [allPO, setAllPO] = useState([]);
  const loadAllPO = async () => {
    try {
      const days_diff = moment(dateTo).diff(dateFrom, "days");
      if (days_diff > 31) {
        setAllPO([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (days_diff < 0) {
        setAllPO([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      preloader(true);
      let date_from = moment(dateFrom).format("YYYY-MM-DD"),
        date_to = moment(dateTo).format("YYYY-MM-DD");
      let url = process.env.REACT_APP_BASEURL + "productpurchaseorders/getall";
      const response = await postSubmitForm(url, {
        date_from,
        date_to,
      });
      if (response && response.status === 1) {
        preloader(false);
        setAllPO(response?.data);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const [allItems, setAllItems] = useState([]);
  const loadAllProducts = async () => {
    let url = process.env.REACT_APP_BASEURL + "products/get_for_po";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const updatedItems = response.data.map((item) => ({
        ...item,
        label: item.name,
        value: item._id,
        item_id: item._id,
        total_price: 0,
      }));
      const SortedData = updatedItems.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      setAllItems(SortedData);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [selectedItem, setSelectedItem] = useState();
  const [receiveModal, setReceiveModal] = useState(false);
  function ReceiveFormatter(cell, row) {
    let isDisabled = row.isFullyReceived;
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(row.receive && row.receive)}
          </span>
          {selectedPO && selectedPO.status != "Closed" && (
            <Button
              className="btn btn-success btn-sm"
              hidden={isDisabled}
              onClick={() => {
                let updatedItem = {
                  ...row,
                  quantity: row.receive?.map((item, idx) => ({
                    ...item,
                    index: idx,
                    isChecked: true,
                  })),
                };
                setSelectedItem(updatedItem);
                setReceiveModal(!receiveModal);
              }}
            >
              <i class="mdi mdi-edit"></i>
              {props.t("Edit")}
            </Button>
          )}
        </div>
      </>
    );
  }

  const [addFreeunitModal, setAddFreeunitModal] = useState(false);
  const [editFreeunitModal, setEditFreeunitModal] = useState(false);
  const [freeGoods, setFreeGoods] = useState([]);
  function EditUnits(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(row.receive && row.receive)}
          </span>
          {selectedPO.status !== "Delivered" &&
            selectedPO.status !== "Closed" && (
              <>
                {row.receive && row.receive?.length > 0 ? (
                  <Button
                    className="btn btn-success btn-sm"
                    onClick={() => {
                      let updatedItem = {
                        ...row,
                        quantity: row.receive?.map((item, idx) => ({
                          ...item,
                          index: idx,
                          isChecked: true,
                        })),
                      };
                      setSelectedItem(updatedItem);
                      setEditFreeunitModal(true);
                    }}
                  >
                    <i class="mdi mdi-edit"></i>
                    {props.t("Edit")}
                  </Button>
                ) : (
                  <Button
                    className="btn btn-success btn-sm"
                    onClick={() => {
                      setSelectedItem(row);
                      setAddFreeunitModal(!addFreeunitModal);
                    }}
                  >
                    <i class="mdi mdi-edit"></i>
                    {props.t("Add")}
                  </Button>
                )}
              </>
            )}
        </div>
      </>
    );
  }

  const [itemsModal, setItemsModal] = useState();
  const [selectedPO, setSelectedPO] = useState();
  function editFormatter(cell, row) {
    setReceiveBtnDisabled(false);
    return (
      <>
        <span className=" mr-2">
          <i
            className="mdi mdi-text-box-search font-size-15"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedPO(row);
              setReceiveBtnDisabled(false);
              setFreeGoods([]);
              let arr = JSON.parse(JSON.stringify(row.products));
              arr.forEach(
                (obj) => (
                  (obj.item_id = obj.product_id),
                  (obj.old_price = obj.price),
                  (obj.receive = obj.receive?.map((obj, index) => ({
                    index,
                    unit: obj.unit,
                    value: obj.value,
                    isChecked: true,
                  }))),
                  (obj.isFullyReceived = obj.receive?.every(
                    ({ value }) => value == 0 || value === "",
                  )),
                  (obj.expiry_date = oneYearFromNow)
                ),
              );
              setPOItems(arr);
              setInvoiceNumber();
              setInvoice();
              setItemsModal(!itemsModal);
            }}
          ></i>
        </span>
        <span className="mr-2 text-info">
          <a
            href={"/purchase_order?fp_po_id=" + row._id}
            target="_blank"
            className="font-size-11"
          >
            <i
              className="mdi mdi-printer font-size-15"
              title="Print PO"
              style={{ cursor: "pointer" }}
            ></i>
          </a>
        </span>
      </>
    );
  }

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "Approved":
        return "success";
      case "Pending":
      case "Pending Approval":
        return "warning";
      case "Partially Delivered":
        return "info";
      case "Closed":
        return "secondary";
      default:
        return "primary";
    }
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("PO ID"),
      dataField: "po_id",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Store Name"),
      dataField: "branch_details.name",
      sort: true,
      headerStyle: () => ({ width: "15%" }),
      //  filter: selectFilter({
      //    options: () => {
      //      const unique = [...new Map(
      //        [...new Set(allPO.map(({ branch_details: value }) => ({
      //          value: value.name,
      //          label: value.name,
      //        })))].map((item) => [item["value"], item])
      //      ).values()];
      //      return unique.sort(dynamicSort("label"));
      //    },
      //  }),
    },
    {
      dataField: "status",
      text: props.t("Status"),
      formatter: (cell, row) => (
        <div>
          <div className={`badge badge-${getStatusBadgeColor(cell)}`}>
            {cell}
          </div>
          {row.status === "Closed" && (
            <div className="mt-1 small">
              {row.closing_remark && (
                <div className="text-muted">
                  <i className="mdi mdi-comment-text-outline mr-1"></i>
                  {row.closing_remark}
                </div>
              )}
              {row.manual_closed_by && (
                <div className="text-muted">
                  <i className="mdi mdi-account mr-1"></i>
                  Manually closed by - {row.manual_closed_by}
                </div>
              )}
            </div>
          )}
          {row.status !== "Pending" && row.received_by && (
            <div className="text-muted small">
              <i className="mdi mdi-account-check mr-1"></i>
              Received by: {row.received_by}
            </div>
          )}
        </div>
      ),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allPO.map(({ status: value }) => ({
                    value: value,
                    label: value,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          // console.log(unique);
          return unique;
        },
        style: {
          height: "25px",
          padding: "0px",
          marginLeft: "10px",
        },
      }),
    },
    {
      dataField: "createdAt",
      text: props.t("Order Date"),
      formatter: (cell) => moment(cell).format("DD/MM/YYYY HH:mm"),
      sort: true,
      headerStyle: () => ({ width: "10%" }),
    },
    {
      text: props.t("Action"),
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
  ];

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },

    {
      dataField: "price",
      text: props.t("Price"),
      formatter: (cell, row) => {
        return row.old_price + "/" + row.unit_for_cost_price;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      editable: false,
    },
    {
      dataField: "price",
      text: props.t("New Price"),
      editable: (cell, row) => {
        return !row.isFullyReceived;
      },
      hidden: selectedPO?.status === "Closed",
      formatter: (cell, row) => {
        return row.price + "/" + row.unit_for_cost_price;
      },
      attrs: (cell, row, rowIndex, colIndex) => {
        return { title: "Click to Edit" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        let isDisabled = row.isFullyReceived;
        if (selectedPO?.status === "Closed" || isDisabled) {
          return { cursor: "default" };
        }
        return { cursor: "pointer", background: "#ffffaa" };
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: props.t("To Receive"),
      editable: false,
      formatter: ReceiveFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        let isDisabled = row.isFullyReceived;
        if (selectedPO?.status === "Closed" || isDisabled) {
          return { cursor: "default" };
        }
        return { cursor: "pointer", background: "#ffffaa" };
      },
    },
    {
      dataField: "expiry_date",
      text: "Expiry",
      editable: true,
      formatter: (cell, row) => {
        let dateObj = cell;
        if (typeof cell !== "object") {
          dateObj = new Date(cell);
        }
        return row.expiry_date;
      },
      editor: {
        type: Type.DATE,
      },
      hidden: selectedPO?.status === "Closed",
      validator: (newValue, row) => {
        const today = moment().startOf("day");

        if (!newValue) {
          return {
            valid: false,
            message: "Expiry date is required.",
          };
        }

        if (!moment(newValue).isValid()) {
          return {
            valid: false,
            message: "Please enter a valid date.",
          };
        }

        if (moment(newValue).isBefore(today)) {
          return {
            valid: false,
            message: "Expiry date cannot be in the past.",
          };
        }

        return true;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
  ];

  const columns_free_goods = [
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "section",
      text: props.t("Section"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: props.t("To Receive"),
      editable: false,
      formatter: EditUnits,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
    },
    {
      dataField: "expiry_date",
      text: "Expiry",
      editable: true,
      formatter: (cell, row) => {
        let dateObj = cell;
        if (typeof cell !== "object") {
          dateObj = new Date(cell);
        }
        return row.expiry_date;
      },
      editor: {
        type: Type.DATE,
      },
      validator: (newValue, row) => {
        const today = moment().startOf("day");

        if (!newValue) {
          return {
            valid: false,
            message: "Expiry date is required.",
          };
        }

        if (!moment(newValue).isValid()) {
          return {
            valid: false,
            message: "Please enter a valid date.",
          };
        }

        if (moment(newValue).isBefore(today)) {
          return {
            valid: false,
            message: "Expiry date cannot be in the past.",
          };
        }

        return true;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];

  const columns_delivered_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "section",
      text: props.t("Section"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "price",
      text: props.t("Price"),
      formatter: (cell, row) => {
        return row.price ? row.price + "/" + row.unit_for_cost_price : 0;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
    },
    {
      dataField: "free",
      text: props.t("Free"),
      formatter: (cell, row) => {
        return row.free ? "YES" : "NO";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: props.t("Received"),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.receive);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "receiving_date",
      text: props.t("Receiving Date"),
      editable: false,
      formatter: (cell, row) => {
        return moment(row.receiving_date).format("DD/MM/YYYY HH:mm");
      },

      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "expiry_date",
      text: "Expiry",
      formatter: (cell, row) => {
        let dateObj = cell;
        if (typeof cell !== "object") {
          dateObj = new Date(cell);
        }
        return row.expiry_date;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "invoice_number",
      text: props.t("Invoice"),
      editable: false,
      formatter: (cell, row) => {
        if (row.invoice_url) {
          return (
            <a href={row.invoice_url}>
              <i
                className="mdi mdi-download font-size-15"
                title="Download Invoice"
              ></i>
            </a>
          );
        } else {
          return row.invoice_number;
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
  ];

  const [showReceiveConfirm, setShowReceiveConfirm] = useState(false);
  const handleReceiveItems = async (e) => {
    e.preventDefault();
    const expiryValidation = CheckExpiryDateValidation(
      POItems,
      freeGoods || [],
    );
    if (!expiryValidation.isValid) {
      showNotification(expiryValidation.message, "Warning");
      return;
    }
    setShowReceiveConfirm(true);
  };

  const processReceiveItems = async () => {
    try {
      let updatedPOItems;
      if (freeGoods && freeGoods.length > 0) {
        updatedPOItems = POItems.concat(freeGoods);
      } else {
        updatedPOItems = POItems;
      }
      let item_to_send = updatedPOItems
        .filter((obj) => obj.receive?.some(({ value }) => value != 0))
        .map((item) => ({
          _id: item._id,
          product_id: item.item_id,
          name: item.name,
          category: item.category,
          section: item.section,
          unit_for_cost_price: item.unit_for_cost_price,
          price: +item.price,
          free: item.free == "yes" ? true : false,
          total_price:
            item.free != "yes"
              ? calculatePrice(
                  item.unit_levels,
                  item.receive,
                  item.price,
                  item.unit_for_cost_price,
                )
              : 0,
          unit_levels: item.unit_levels,
          quantity: item.quantity?.length > 0 ? item.quantity : [],
          expiry_date: item.expiry_date,
          receive: item.receive.map((receiveItem) => ({
            unit: receiveItem.unit,
            value: Number(receiveItem.value),
          })),
        }));
      let formData = new FormData();
      formData.set("id", selectedPO._id);
      formData.set("delivery_details", JSON.stringify(item_to_send));
      formData.append("invoice_number", invoiceNumber);
      formData.append("invoice", invoice);

      setReceiveBtnDisabled(true);
      let url = process.env.REACT_APP_BASEURL + "productpurchaseorders/receive";
      const response = await postSubmitForm_withformdata(url, formData);

      if (response && response.status === 1) {
        loadAllPO();
        setFreeGoods([]);
        setItemsModal(!itemsModal);
        showNotification(response.message, "Success");
      } else {
        setReceiveBtnDisabled(false);
        setReceiveBtnDisabled(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setReceiveBtnDisabled(false);
      showNotification("Error processing request", "Error");
    }
  };

  const handleSubmit = (quantity) => {
    // event.preventDefault();
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    setReceiveModal(!receiveModal);
    const updatedItems = POItems.map((item) => {
      if (item._id === selectedItem._id) {
        return { ...item, receive: convertedQuantity };
        // return selectedItem;
      }
      return item;
    });
    setSelectedItem();
    setPOItems(updatedItems);
  };

  const handleClosePO = async (remarks) => {
    let url = process.env.REACT_APP_BASEURL + "productpurchaseorders/close";
    const response = await postSubmitForm(url, {
      id: selectedPO._id,
      closing_remark: remarks,
    });
    if (response && response.status === 1) {
      setItemsModal(!itemsModal);
      loadAllPO(response.data);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handlAddFreeGoods = () => {
    const isValid = freeGoods.every(
      (item) => item.receive && item.receive.every((row) => row.value == 0),
    );
    if (isValid) {
      showNotification("Enter valid quantity for each item", "Warning");
      return;
    }
    setFreeGoodsModal(!freeGoodsModal);
  };
  // for free goods
  const handleAddUnits = (quantity) => {
    // console.log(quantity,"from free");
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    const updatedCartItems = freeGoods.map((item) => {
      if (item._id === selectedItem._id) {
        // return { ...item, receive: selectedRowsUnit.map(row => ({ unit: row.unit, value: row.value })), free: "yes" };
        return { ...item, receive: convertedQuantity, free: "yes" };
      } else {
        return item;
      }
    });
    setFreeGoods(updatedCartItems);
    setSelectedItem([]);
    setAddFreeunitModal(false);
  };

  const handleUpdateUnit = (quantity) => {
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    const isItemInCart = freeGoods.some(
      (item) => item.item_id === selectedItem.item_id,
    );
    if (isItemInCart) {
      const updatedCartItems = freeGoods.map((item) =>
        item.item_id === selectedItem.item_id
          ? {
              ...item,
              receive: convertedQuantity,
            }
          : item,
      );
      setFreeGoods(updatedCartItems);
      setEditFreeunitModal(false);
    } else {
      const newItem = {
        ...selectedItem,
        receive: convertedQuantity,
      };
      setFreeGoods((prevCartItems) => [...prevCartItems, newItem]);
      setEditFreeunitModal(false);
    }
  };

  const [freeGoodsModal, setFreeGoodsModal] = useState(false);
  const handleSelectItems = (data, changedValue) => {
    // select logic
    if (changedValue.action === "select-option") {
      const modifiedData = data.map((item) => {
        return {
          item_id: item._id,
          _id: item._id,
          label: item.label,
          value: item.value,
          name: item.name,
          category: item.category,
          section: item.section,
          free: item.free && item.free,
          receive: item.receive && item.receive,
          unit_for_cost_price: item.unit_for_cost_price,
          price: 0,
          total_price: 0,
          expiry_date: oneYearFromNow,
          unit_levels: item.unit_levels.map(({ unit, value }) => ({
            unit,
            value,
          })),
        };
      });
      setFreeGoods(modifiedData);
    }
    if (changedValue.action === "remove-value") {
      let UpdatedSelectedItem = freeGoods?.filter(
        (item) => item.label !== changedValue.removedValue.label,
      );
      setFreeGoods(UpdatedSelectedItem);
    }
  };
  const [invoiceNumber, setInvoiceNumber] = useState();
  const [invoice, setInvoice] = useState();

  const handleDownload = async () => {
    const fileName = "all_purchase_orders";
    const exportType = "xls";

    let data_to_export = allPO;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          POID: v.po_id,
          Branch: v.branch_details.name,
          Date: moment(v.createdAt).format("DD/MM/YYYY HH:mm"),
          Status: v.status,
          Closing_Remark: v.closing_remark,
          Received_By: v.received_by,
          Manual_Closed_By: v.manual_closed_by,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Requisition")}
            alternateTitle={props.t("FP Purchase Orders")}
            breadcrumbItem1={props.t("All Purchase Orders")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4} md={4} xl={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4} md={4} xl={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4} md={4} xl={4}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadAllPO();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allPO && allPO}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(propss) => (
                        <div>
                          <Row>
                            <Col
                              lg={4}
                              sm={4}
                              md={4}
                              xl={4}
                              className="d-print-none"
                            >
                              <SearchBar
                                {...propss.searchProps}
                                style={{ width: "250px" }}
                              />
                            </Col>
                            <Col sm={4} lg={4} md={4} xl={4}>
                              <CardTitle className="text-center">
                                {props.t("All FP Purchase Orders")}
                              </CardTitle>
                            </Col>
                            <Col
                              sm={4}
                              lg={4}
                              md={4}
                              xl={4}
                              className="text-right d-print-none"
                            >
                              <Button
                                type="submit"
                                className="btn btn-sm btn-secondary"
                                onClick={handleDownload}
                              >
                                <i className="mdi mdi-file-export"></i>{" "}
                                {props.t("Export CSV")}
                              </Button>
                              {"   "}
                              <Link
                                to="#"
                                onClick={() => {
                                  printDiv("printDiv");
                                }}
                                className="btn btn-sm btn-success mr-2"
                              >
                                <i className="fa fa-print"></i> Print
                              </Link>
                              <div className="search-box mr-2 mb-2 d-inline-block">
                                <div className="position-relative"></div>
                              </div>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            filter={filterFactory()}
                            condensed
                            {...propss.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  <Modal
                    size="lg"
                    style={{
                      minWidth: "1200px",
                      maxWidth: "1200px",
                    }}
                    isOpen={itemsModal}
                    toggle={() => setItemsModal(!itemsModal)}
                  >
                    <ModalHeader toggle={() => setItemsModal(!itemsModal)}>
                      Purchase Order ID: {selectedPO && selectedPO.po_id}{" "}
                      {selectedPO && selectedPO.status != "Closed" && (
                        <Button
                          type="submit"
                          className="btn-rounded btn btn-danger"
                          onClick={() => {
                            setConfirmClose(true);
                          }}
                        >
                          {props.t("Close")}
                        </Button>
                      )}
                      <ConfirmationDialogue
                        isOpen={confirmClose}
                        title="Close Purchase Order"
                        message="Once you close this purchase order, it cannot be revoked."
                        remarksLabel="Please enter remarks for closing this PO"
                        onConfirm={(remarks) => {
                          handleClosePO(remarks);
                        }}
                        onCancel={() => {
                          setConfirmClose(false);
                        }}
                      />
                    </ModalHeader>
                    <ModalBody>
                      {selectedPO && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <Label>Ordered Products</Label>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={POItems && POItems}
                                        columns={columns_items}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              cellEdit={cellEditFactory({
                                                mode: "click",
                                                blurToSave: true,
                                              })}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                    {selectedPO.status !== "Delivered" &&
                                      selectedPO.status !== "Closed" && (
                                        <>
                                          <Col lg={12}>
                                            <Row>
                                              <Col lg={12}>
                                                <AvForm
                                                  onValidSubmit={
                                                    handleReceiveItems
                                                  }
                                                >
                                                  <Row>
                                                    <Col lg={4}>
                                                      <Label>
                                                        Invoice Number
                                                      </Label>
                                                      <AvField
                                                        type="text"
                                                        name="invoice_number"
                                                        value={invoiceNumber}
                                                        onChange={(e) =>
                                                          setInvoiceNumber(
                                                            e.target.value,
                                                          )
                                                        }
                                                        placeholder={props.t(
                                                          "Enter invoice no. here...",
                                                        )}
                                                        validate={{
                                                          required: {
                                                            value: true,
                                                            errorMessage:
                                                              props.t(
                                                                "Invoice no. is required.",
                                                              ),
                                                          },
                                                          minLength: {
                                                            value: 3,
                                                            errorMessage:
                                                              props.t(
                                                                "must be at least 3 characters.",
                                                              ),
                                                          },
                                                        }}
                                                      />
                                                    </Col>
                                                    <Col lg={4}>
                                                      <Label>
                                                        Upload Invoice Document
                                                      </Label>
                                                      <Input
                                                        type="file"
                                                        id="invoice"
                                                        className="form-control-file"
                                                        onChange={(e) => {
                                                          setInvoice(
                                                            e.target.files[0],
                                                          );
                                                        }}
                                                      />
                                                    </Col>
                                                    <Col
                                                      lg={4}
                                                      className="d-flex align-items-end mb-4"
                                                    >
                                                      <Button
                                                        type="button"
                                                        color="info"
                                                        className="btn btn-info waves-effect waves-light"
                                                        onClick={() =>
                                                          setFreeGoodsModal(
                                                            !freeGoodsModal,
                                                          )
                                                        }
                                                      >
                                                        <i className="bx bx-add-to-queue me-1"></i>
                                                        {props.t(
                                                          "Add Free Goods",
                                                        )}
                                                      </Button>
                                                    </Col>
                                                    <Col
                                                      lg={12}
                                                      className="text-center mt-3"
                                                    >
                                                      <Button
                                                        type="submit"
                                                        color="primary"
                                                        style={{
                                                          width: "140px",
                                                        }}
                                                        disabled={
                                                          receiveBtnDisabled
                                                        }
                                                        className="btn btn-default waves-effect waves-light"
                                                      >
                                                        {receiveBtnDisabled ? (
                                                          <Spinner size="sm" />
                                                        ) : (
                                                          props.t("Receive")
                                                        )}
                                                      </Button>
                                                    </Col>
                                                  </Row>
                                                </AvForm>
                                              </Col>
                                            </Row>
                                            <hr className="mt-2" />
                                          </Col>
                                        </>
                                      )}
                                  </Row>
                                  <Row>
                                    <Col lg={12}>
                                      <Label>Delivered Products</Label>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedPO &&
                                          selectedPO.delivery_details
                                        }
                                        columns={columns_delivered_items}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              cellEdit={cellEditFactory({
                                                mode: "click",
                                                blurToSave: true,
                                              })}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {/* Update Receive  Quantity PO Items */}
                  <UpdateQuantityModal
                    isOpen={receiveModal}
                    toggle={() => setReceiveModal(false)}
                    onSubmit={handleSubmit}
                    item={selectedItem}
                  />

                  {/* Add Free goods modal  */}
                  <Modal
                    size="lg"
                    isOpen={freeGoodsModal}
                    toggle={() => setFreeGoodsModal(!freeGoodsModal)}
                  >
                    <ModalHeader
                      toggle={() => setFreeGoodsModal(!freeGoodsModal)}
                    >
                      {props.t("Add Free Goods")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={6}>
                          <Label>{props.t("Items")}</Label>
                          <Select
                            options={allItems}
                            value={freeGoods}
                            onChange={(data, changedValue) =>
                              handleSelectItems(data, changedValue)
                            }
                            closeMenuOnSelect={true}
                            classNamePrefix="select"
                            isMulti={true}
                            className="basic-multi-select"
                          />
                        </Col>
                      </Row>
                      <Row className="mt-5">
                        <Col lg={12}>
                          <Label>{props.t("Free Goods")}</Label>
                          <ToolkitProvider
                            keyField="_id"
                            data={freeGoods || []}
                            columns={columns_free_goods}
                          >
                            {(props) => (
                              <div>
                                <BootstrapTable
                                  {...props.baseProps}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  noDataIndication="No data to display."
                                  striped
                                  hover
                                  condensed
                                />
                              </div>
                            )}
                          </ToolkitProvider>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col lg={12}>
                          <FormGroup className="mb-0 text-center">
                            <div>
                              <Button
                                type="submit"
                                color="primary"
                                className="mr-1"
                                onClick={() => handlAddFreeGoods()}
                              >
                                {props.t("Submit")}
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                  {/* Add unit modal  */}
                  <EnterQuantityModal
                    // selectedQuantity={selectedRowsUnit}
                    isOpen={addFreeunitModal}
                    toggle={() => setAddFreeunitModal(false)}
                    onSubmit={handleAddUnits}
                    item={selectedItem}
                  />

                  {/* Edit Units Modal  */}
                  <UpdateQuantityModal
                    isOpen={editFreeunitModal}
                    toggle={() => setEditFreeunitModal(false)}
                    onSubmit={handleUpdateUnit}
                    item={selectedItem}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ReceiveConfirmationDialog
            isOpen={showReceiveConfirm}
            onConfirm={() => {
              setShowReceiveConfirm(false);
              processReceiveItems({
                POItems,
                freeGoods,
                invoiceNumber,
                invoice,
              });
            }}
            onCancel={() => {
              setShowReceiveConfirm(false);
            }}
            hasFreeGoods={freeGoods?.length > 0}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(FinishedProductView)),
);
